import { useSearchParams } from "react-router-dom";
import { useBroker } from "../../APIContext/BrokerContext";
import { useState } from "react";
import Swal from "sweetalert2";
import "./SuccessFailPage.css";
import NavbarCustomBroker from "../../Components/NavbarCustomBroker";

export default function SuccessFailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("status");
  const { acknowledgeBroker } = useBroker();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!token) {
      Swal.fire("Invalid Link", "Token is missing or invalid.", "error");
      return;
    }

    try {
      setLoading(true);
      await acknowledgeBroker(token);

    await Swal.fire({
      title: "MOU Confirmed!",
      text: "The agreement has been successfully activated.",
      icon: "success",
      confirmButtonText: "Go Back",
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      
    });

    window.history.back();

    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while confirming.",
        icon: "error",
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="broker-confirm-page">
      <NavbarCustomBroker />
      <div className="confirm-card">
        <h2 className="confirm-title black-text-clip">Confirm MOU</h2>

        <p className="confirm-text black-text-clip">
          You have been requested to confirm and activate this Memorandum of Understanding.
          Please click below to continue.
        </p>

        <button
          className="confirm-btn"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? "Confirming..." : "CONFIRM MOU"}
        </button>
      </div>
    </div>
  );
}
